export const IMPERIAL = 'Imperial';
export const METRIC = 'Metric';

export const DEFAULT_UOM = IMPERIAL;

export const UNITS = {
  pressure: {
    kPa: 'kPa',
    mbar: 'mbar'
  },
  radon: {
    pciL: 'pCi/L',
    bqM3: 'Bq/m³'
  },
  temperature: {
    celsius: '\u2103',
    fahrenheit: '\u2109'
  },
  humidity: '%'
};

export const SYSTEMS_OF_MEASURE = {
  [IMPERIAL]: {
    radon: UNITS.radon.pciL,
    temperature: UNITS.temperature.fahrenheit,
    humidity: UNITS.humidity,
    pressure: UNITS.pressure.kPa
  },
  [METRIC]: {
    radon: UNITS.radon.bqM3,
    temperature: UNITS.temperature.celsius,
    humidity: UNITS.humidity,
    pressure: UNITS.pressure.mbar
  }
};


// WEBPACK FOOTER //
// src/constants/uom.js